<template>
  <div
    class="t-grid grid"
    :class="[colsClasses[cols], gapXClasses[gapX], gapYClasses[gapY]]"
  >
    <slot />
  </div>
</template>
<script setup lang="ts">
const colsClasses = {
  8: 'grid-cols-8',
  9: 'grid-cols-9',
  10: 'grid-cols-10',
  12: 'grid-cols-12',
}

const gapXClasses = {
  4: 'gap-x-4',
  8: 'gap-x-8',
}

const gapYClasses = {
  0: '',
  4: 'gap-y-4',
  6: 'gap-y-6',
  8: 'gap-y-8',
}

interface Props {
  cols?: 8 | 9 | 10 | 12
  gapX?: 4 | 8
  gapY?: 0 | 4 | 6 | 8
}
withDefaults(defineProps<Props>(), {
  cols: 12,
  gapX: 4,
  gapY: 0,
})
</script>
